import { render, staticRenderFns } from "./TreatmentsSetting.vue?vue&type=template&id=0e8b4d80&scoped=true&"
import script from "./TreatmentsSetting.vue?vue&type=script&lang=js&"
export * from "./TreatmentsSetting.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentsSetting.vue?vue&type=style&index=0&id=0e8b4d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8b4d80",
  null
  
)

export default component.exports